import { useTranslation } from "react-i18next";
import {DatePicker, Form, Layout, Modal, Select, Tabs} from "antd";
import PageHeader from "../../../components/page-header/PageHeader";
import {FormInstance} from "antd/lib";
import React, {useEffect, useState} from "react";
import "./index.scss";
import {AppstoreOutlined, BarChartOutlined} from "@ant-design/icons";
import FilterTable from "./component/filter-table/FilterTable";
import FormFilter from "./component/filter-group/FormFilter";
import dayjs from "dayjs";
import {
  exportAllFeedbackAndEvaluation,
  exportAllResource,
  exportAllUserBehavior,
  getCourseFilterUniversity,
  getCourseLevel,
  getCurrentUniversity,
  getIndustryGroupFilterUniversity,
  getTeacherFilterUniversity
} from "../../../service/statistical-report";
import OverviewTab from "./component/tab/OverviewTab";
import {globalStore, staticReportStore} from "../../../stores/stores";
import FeedbackAndEvaluationTab from "./component/tab/FeedbackAndEvaluationTab";
import UserBehaviorTab from "./component/tab/UserBehaviorTab";
import ResourceTab from "./component/tab/ResourceTab";

type Props = {
  title: string;
};
const {Option} = Select;
const StatisticalReportForMinistry = (props: Props) => {
  const { t } = useTranslation();
  const {title} = props;
  const {reload} = globalStore();
  const {tab, setTab, callExportAllImages, exportType, setExportType} = staticReportStore();
  const [form] = Form.useForm();
  const [isRendering, setIsRendering] = useState<boolean>(false);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDisplayTime, setIsDisplayTime] = useState<boolean>(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectionTime, setSelectionTime] = useState("");
  const {filterValues, setFilterValues} = staticReportStore();
  const [dataType, setDataType] = useState<string>("1");
  const [universityId, setUniversityId] = useState<number>(0);
  const [dataOptions, setDataOptions] = useState({
    dataLecturer: [],
    dataLevel: [],
    dataUnit: [],
    dataCourse: [],
  });
  const handlFromDateChange = (date: any) => {
    setFromDate(date);
    if (toDate && date > toDate) {
      setToDate(date);
    }
  };
  const handleToDateChange = (date: any) => {
    setToDate(date);
  };

  const items = [
    {
      value: "7day",
      label: t("7 ngày trước", "7 ngày trước"),
    },
    {
      value: "1month",
      label: t("1 tháng trước", "1 tháng trước"),
    },
    {
      value: "3month",
      label: t("3 tháng gần đây", "3 tháng gần đây"),
    },
    {
      value: "option",
      label: t("Tùy chọn", "Tùy chọn"),
    },
  ];

  const handleMenuClick = (value: any) => {
    let dateFrom, dateTo = dayjs();
    let timeUnit = "";

    if (value === "option") {
      setIsModalVisible(true);
    } else {
      setIsModalVisible(false);
      setIsDisplayTime(false);
      switch (value) {
        case "7day":
          dateFrom = dayjs().subtract(7, "day");
          timeUnit = "day";
          break;
        case "1month":
          dateFrom = dayjs().subtract(1, "month");
          timeUnit = "week";
          break;
        case "3month":
          dateFrom = dayjs().subtract(3, "month");
          timeUnit = "month";
          break;
        default:
          dateFrom = dayjs().subtract(7, "day");
          timeUnit = "day";
      }

      setFilterValues({
        timeUnit: timeUnit,
        dateFrom: dateFrom,
        dateTo: dateTo,
      });
    }
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  }
  const handleOk = () => {
    setIsDisplayTime(true);
    form.submit();
    setIsModalVisible(false);
  }

  // 1: chart
  // 2: table
  const tabItems = [
    {
      label: t("Tổng quan", "Tổng quan"),
      key: "1",
      children: <OverviewTab dataType={dataType} universityId={universityId}/>,
    },
    {
      label: t("Tài nguyên", "Tài nguyên"),
      key: "2",
      children: <ResourceTab dataType={dataType} universityId={universityId}/>,
    },
    {
      label: t("Phản hồi & đánh giá", "Phản hồi & đánh giá"),
      key: "3",
      children: <FeedbackAndEvaluationTab dataType={dataType} universityId={universityId}/>,
    },
    {
      label: t("Hành vi người dùng", "Hành vi người dùng"),
      key: "4",
      children: <UserBehaviorTab dataType={dataType} universityId={universityId}/>,
    },
  ];

  const tabItemsTimeFilter = [
    {
      label: <BarChartOutlined/>,
      key: "1",
    },
    {
      label: <AppstoreOutlined/>,
      key: "2",
    },
  ];

  const handleChangeType = (e: any) => {
    setDataType(e);
  }

  const dropdownMenu = (
    <>
      <div style={{alignSelf: "center", color: "#1677FF", display: isDisplayTime ? "" : "none"}}>{selectionTime}</div>
      <Select
        defaultValue={"7day"}
        style={{minWidth: 150, alignSelf: "center"}}
        onSelect={(value) => {
          handleMenuClick(value)
        }}
        options={items}
        variant="borderless"
      />
      <Tabs
        className="tabs-time-filter"
        defaultActiveKey="1"
        items={tabItemsTimeFilter}
        onChange={handleChangeType}
        centered={true}
      />
    </>
  );

  const onChangeTab = (key: string) => {
    setTab(key);
  };

  // Filter Search
  const handleOpenFilter = () => {
    setShowFilter((showFilter) => !showFilter);
  };

  const clearFilter = (form: FormInstance) => {
    form.resetFields();
    setFilterValues({
      lecturerIds: [],
      courseLevelIds: [],
      industryGroupIds: [],
      courseIds: [],
      // timeUnit: "day",
      // dateFrom: dayjs().subtract(7, "day"),
      // dateTo: dayjs(),
    });
  };

  const handleFinish = (values: any) => {
    setFilterValues({
      ...filterValues,
      lecturerIds: values.lecturer ? values.lecturer : [],
      courseLevelIds: values.level ? values.level : [],
      industryGroupIds: values.unit ? values.unit : [],
      courseIds: values.course ? values.course : [],
    })
  };

  const handleFinishTimeOptionForm = (values: any) => {
    if (Object.keys(values).length > 0) {
      setFilterValues({
        ...filterValues,
        timeUnit: values.timeUnit ? values.timeUnit : "day",
        dateFrom: values.dateFrom,  
        dateTo: values.dateTo,
      })
    }
  }

  const handleExportAll = async (type: string) => {
    if (dataType === "1") {
      try {
        setIsRendering(true);
        await callExportAllImages(tab);
      } catch(err) {
        console.error("Error downloading file:", err);
      } finally {
        setIsRendering(false);
      }
    } else {
      const fileExtension = type === "excel" ? "xlsx" : "pdf";
      const payloads = {
        from: dayjs(filterValues.dateFrom).toISOString(),
        to: dayjs(filterValues.dateTo).toISOString(),
        courseLevelIds: filterValues?.courseLevelIds,
        industryGroupIds: filterValues?.industryGroupIds,
        courseIds: filterValues?.courseIds,
        timeUnit: filterValues?.timeUnit,
        exportType: type === "excel" ? "excel" : "pdf",
      };
      try {
        setIsRendering(true);
        const exportApiUrl =
          tab === "1"
            ? exportAllResource({...payloads})
            : tab === "2"
              ? exportAllFeedbackAndEvaluation({
                ...payloads,
                moduleGroup: filterValues?.moduleGroup,
                classId: filterValues?.classId,
              })
              : tab === "3"
                ? exportAllUserBehavior({
                  ...payloads,
                  courseStructureType:
                  filterValues?.searchKeywordCourseStructureType,
                  moduleGroup: filterValues?.searchKeywordModuleGroup,
                  downloadModuleGroup: filterValues?.downloadModuleGroup,
                  downloadCourseStructureType:
                  filterValues?.downloadCourseStructureType,
                  viewModuleGroup: filterValues?.viewModuleGroup,
                  viewCourseStructureType: filterValues?.viewCourseStructureType,
                  shareModuleGroup: filterValues?.shareModuleGroup,
                  shareCourseStructureType:
                  filterValues?.shareCourseStructureType,
                })
                : exportAllResource({...payloads});

        const res = await exportApiUrl;
        const fileName =
          tab === "1"
            ? `Tai-nguyen.${fileExtension}`
            : tab === "2"
              ? `Phan-hoi-danh-gia.${fileExtension}`
              : tab === "3"
                ? `Hanh-vi-nguoi-dung.${fileExtension}`
                : `excel.${fileExtension}`;
        const fileData = new Blob([res.data], {
          type:
            type === "excel"
              ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              : "application/pdf",
        });

        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(fileData);
        downloadLink.download = fileName;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      } catch (error) {
        console.error("Error downloading Excel file:", error);
      } finally {
        setIsRendering(false);
      }
    }
  };

  const getCurrentUniversityId = async () => {
    await getCurrentUniversity().then((res) => {
      if(res.status === 200) {
        setUniversityId(res.data.data);
      }
    })
  }

  // useEffect
  useEffect(() => {
    Promise.all([getTeacherFilterUniversity(), getIndustryGroupFilterUniversity(), getCourseFilterUniversity(), getCourseLevel()]).then((res) => {
      const dataLecturerList = res[0].data.data;
      const dataIndustryList = res[1].data.data;
      const dataCourseList = res[2].data.data;
      const dataCourseLevelList = res[3].data.data;
      setDataOptions({
        ...dataOptions,
        dataLecturer: dataLecturerList,
        dataUnit: dataIndustryList,
        dataCourse: dataCourseList,
        dataLevel: dataCourseLevelList,
      })
    })
  }, [reload]);
  
  useEffect(() => {
    getCurrentUniversityId();
  }, [reload]);

  useEffect(() => {
    const timeUnitLabel =
      filterValues.timeUnit === "day"
        ? t("Biểu đồ ngày", "Biểu đồ ngày")
        : filterValues.timeUnit === "week"
          ? t("Biểu đồ tuần", "Biểu đồ tuần")
          : filterValues.timeUnit === "month"
            ? t("Biểu đồ tháng", "Biểu đồ tháng")
            : filterValues.timeUnit === "year"
              ? t("Biểu đồ năm", "Biểu đồ năm")
              : t("Chọn tùy chọn thời gian", "Chọn tùy chọn thời gian");

    const dateFrom = filterValues.dateFrom
      ? dayjs(filterValues.dateFrom).format("DD/MM/YYYY")
      : "";
    const dateTo = filterValues.dateTo
      ? dayjs(filterValues.dateTo).format("DD/MM/YYYY")
      : "";

    setSelectionTime(`${timeUnitLabel} - ${t("Từ ngày", "Từ ngày")} ${dateFrom} ${t("Đến ngày", "Đến ngày")} ${dateTo}`);
  }, [filterValues]);

  useEffect(() => {
    handleMenuClick("timeDefault");
  }, []);

  return (
    <Layout className="page-header-group statistical-report-for-university">
      <Form.Provider>
        <div
          className={`page-header-group--layout ${showFilter ? "open-filter" : ""
          }`}
        >
          <div className="table-header--wrapper">
            <div className="table-header--left">
              <PageHeader title={title}/>
            </div>
            <FilterTable
              handleOpenFilter={handleOpenFilter}
              isRendering={isRendering}
              setExportType={setExportType}
              reportType={dataType}
              handleExportAll={handleExportAll}
            />
          </div>
          <FormFilter
            clearFilter={clearFilter}
            dataOptions={dataOptions}
            onFinish={handleFinish}
            showFilter={showFilter}
          />
        </div>
        <div className="chart-table-content-group">
          <Tabs
            defaultActiveKey="1"
            items={tabItems}
            onChange={onChangeTab}
            tabBarExtraContent={
              <div className="filter-button-group">
                {dropdownMenu}
              </div>
            }
          />
        </div>
        <Modal
          title={t("Tùy chọn", "Tùy chọn")}
          open={isModalVisible}
          onCancel={handleCancel}
          okText={t("Xác nhận", "Xác nhận")}
          cancelText={t("Huỷ", "Huỷ")}
          onOk={handleOk}
          okButtonProps={{
            disabled: !fromDate || !toDate,
          }}
        >
          <Form name="time-option-form" labelCol={{span: 6}} onFinish={handleFinishTimeOptionForm} form={form}>
            <Form.Item name="timeUnit" label={t("Đơn vị", "Đơn vị")}>
              <Select defaultValue="day" style={{width: '100%'}}>
                <Option value="day">{t("Biểu đồ ngày", "Biểu đồ ngày")}</Option>
                <Option value="week">{t("Biểu đồ tuần", "Biểu đồ tuần")}</Option>
                <Option value="month">{t("Biểu đồ tháng", "Biểu đồ tháng")}</Option>
                <Option value="year">{t("Biểu đồ năm", "Biểu đồ năm")}</Option>
              </Select>
            </Form.Item>
            <Form.Item name="dateFrom" label={t("Từ ngày", "Từ ngày")}>
              <DatePicker style={{width: '100%'}} format="DD/MM/YYYY" placeholder={t("Chọn ngày", "Chọn ngày")} value={fromDate}
                          onChange={handlFromDateChange} 
                          disabledDate={(current: any) => current && current > dayjs().endOf('day')}/>
            </Form.Item>
            <Form.Item name="dateTo" label={t("Đến ngày", "Đến ngày")}>
              <DatePicker style={{width: '100%'}} format="DD/MM/YYYY" placeholder={t("Chọn ngày", "Chọn ngày")} value={toDate}
                          onChange={handleToDateChange}
                          disabledDate={(current: any) => 
                            current && (fromDate && current < fromDate) || (current > dayjs().endOf('day'))
                          }/>
            </Form.Item>
          </Form>
        </Modal>
      </Form.Provider>
    </Layout>
  );
};

export default StatisticalReportForMinistry;
